export enum UserLicenses {
    CDTIME = 1 << 3,
    CDTIMEFINDER = 1 << 4,
}